module.exports = __webpack_public_path__ + "img/logo-fi.d6179a66.png";